import { CircleCheck, Ruler, Settings, ShieldCheck, Sparkles, Wrench } from "lucide-react";

// Felgen-Hersteller Bilder
import img2drv from "@/assets/felgen-hersteller/2drv.jpg";
import imgAez from "@/assets/felgen-hersteller/aez.webp";
import imgBbs from "@/assets/felgen-hersteller/bbs.webp";
import imgBorbet from "@/assets/felgen-hersteller/borbet.jpg";
import imgDezent from "@/assets/felgen-hersteller/dezent.jpg";
import imgDotz from "@/assets/felgen-hersteller/dotz.jpg";
import imgGmpItalia from "@/assets/felgen-hersteller/gmp-italia.jpg";
import imgMak from "@/assets/felgen-hersteller/mak.jpg";
import imgOzRacing from "@/assets/felgen-hersteller/oz-racing.webp";
import imgPlatin from "@/assets/felgen-hersteller/platin.jpg";


// Felgen-Marken Logos
import logoAez from "@/assets/felgen-marken/aez.png";
import logoAlutec from "@/assets/felgen-marken/alutec.png";
import logoAts from "@/assets/felgen-marken/ats.png";
import logoBarracuda from "@/assets/felgen-marken/barracuda.png";
import logoBorbet from "@/assets/felgen-marken/borbet.png";
import logoBrock from "@/assets/felgen-marken/brock.png";
import logoCms from "@/assets/felgen-marken/cms.png";
import logoCorspeed from "@/assets/felgen-marken/corspeed.png";
import logoDezent from "@/assets/felgen-marken/dezent.png";
import logoDotz from "@/assets/felgen-marken/dotz.png";
import logoGmp from "@/assets/felgen-marken/gmp.png";
import logoKeskin from "@/assets/felgen-marken/keskin.png";
import logoMak from "@/assets/felgen-marken/mak.png";
import logoMam from "@/assets/felgen-marken/mam.png";
import logoMsw from "@/assets/felgen-marken/msw.png";
import logoOxxo from "@/assets/felgen-marken/oxxo.png";
import logoOzRacing from "@/assets/felgen-marken/oz-racing.png";
import logoPlatin from "@/assets/felgen-marken/platin.png";
import logoRcDesign from "@/assets/felgen-marken/rc-design.png";
import logoRial from "@/assets/felgen-marken/rial-v2.png";
import logoRonal from "@/assets/felgen-marken/ronal.png";
import logoSparco from "@/assets/felgen-marken/sparco.png";

export const felgenMarken = [
  { name: "OZ Racing", logo: logoOzRacing },
  { name: "Borbet", logo: logoBorbet },
  { name: "ATS", logo: logoAts },
  { name: "Dotz", logo: logoDotz },
  { name: "Rial", logo: logoRial },
  { name: "Brock", logo: logoBrock },
  { name: "Keskin", logo: logoKeskin },
  { name: "Barracuda", logo: logoBarracuda },
  { name: "Sparco", logo: logoSparco },
  { name: "Dezent", logo: logoDezent },
  { name: "Ronal", logo: logoRonal },
  { name: "CMS", logo: logoCms },
  { name: "Alutec", logo: logoAlutec },
  { name: "MAK", logo: logoMak },
  { name: "OXXO", logo: logoOxxo },
  { name: "Cor.Speed", logo: logoCorspeed },
  { name: "AEZ", logo: logoAez },
  { name: "MSW", logo: logoMsw },
  { name: "GMP", logo: logoGmp },
  { name: "Platin", logo: logoPlatin },
  { name: "MAM", logo: logoMam },
  { name: "RC Design", logo: logoRcDesign },
];

export const schnellInfos = [
  {
    icon: CircleCheck,
    title: "Live-Visualisierung",
    desc: "Wir zeigen dir am Bildschirm, wie verschiedene Felgen auf deinem Auto aussehen, und schicken dir die besten Optionen per E-Mail mit Bildern.",
  },
  {
    icon: ShieldCheck,
    title: "Riesige Auswahl",
    desc: "Hunderte Modelle von sportlich bis klassisch. Wir sind nicht auf Lagerware beschränkt, wir finden genau deine Felge.",
  },
  {
    icon: Wrench,
    title: "In 2–3 Tagen montiert",
    desc: "Felge bestellt, geliefert, montiert, alles aus einer Hand. Die meisten Felgen sind in 2–3 Tagen bei uns und bereit zur Montage.",
  },
];

export const prozessSchritte = [
  { nr: "01", title: "Beratung", text: "Komm vorbei oder schick uns eine Anfrage. Wir zeigen dir am Bildschirm passende Felgen, mit Live-Visualisierung auf deinem Fahrzeug." },
  { nr: "02", title: "Persönliche Offerte", text: "Du bekommst per E-Mail mehrere Angebote mit verschiedenen Felgen, passenden Reifen und Bildern, wie es auf deinem Auto aussieht, abgestimmt auf deine Wünsche und dein Budget." },
  { nr: "03", title: "Montage", text: "Reifen aufziehen, auswuchten, RDKS prüfen, und du fährst mit neuen Rädern vom Hof." },
];

export const felgenWissen = [
  {
    icon: Ruler,
    title: "Zollgrössen",
    text: "Die Felgengrösse wird in Zoll angegeben, von 15\" für Kleinwagen bis 22\" für SUVs. Grössere Felgen sehen sportlicher aus, können aber den Fahrkomfort beeinflussen. Wir beraten dich, welche Grösse zu deinem Auto passt.",
  },
  {
    icon: Settings,
    title: "Einpresstiefe (ET)",
    text: "Die Einpresstiefe bestimmt, wie weit die Felge nach innen oder aussen steht. Ein falscher ET-Wert kann zu Problemen mit Bremsen oder Radkasten führen. Wir prüfen die Kompatibilität für dein Fahrzeug.",
  },
  {
    icon: ShieldCheck,
    title: "MFK-Eintragung",
    text: "In der Schweiz brauchen viele Felgen eine MFK-Abnahme beim Strassenverkehrsamt. Wir haben aber eine sehr grosse Auswahl an CH-homologierten Felgen, die keine MFK brauchen, direkt montieren und losfahren.",
  },
  {
    icon: Sparkles,
    title: "Felgenpflege",
    text: "Regelmässiges Reinigen mit pH-neutralem Felgenreiniger schützt vor Bremsstaub und Korrosion. Im Winter empfehlen wir eine Versiegelung gegen Streusalz. Bei Kratzern oder Bordsteinschäden: unsere Felgenreparatur hilft.",
  },
];

export const locations = [
  {
    name: "Oftringen",
    sub: "Perry Center · Bernstrasse 1, 4665 Oftringen",
    hoursMoFr: "Mo–Fr 08:30–12:00 / 13:15–19:00",
    hoursSa: "Sa 08:00–12:00 / 13:15–16:00",
  },
  {
    name: "Langenthal",
    sub: "Meilenstein · Lotzwilstrasse 66, 4900 Langenthal",
    hoursMoFr: "Mo–Fr 08:00–12:00 / 13:15–18:00",
    hoursSa: "Sa 08:00–12:00 / 13:15–16:00",
  },
];

export const BENEFITS = [
  "Live-Visualisierung, sieh die Felge auf deinem Auto",
  "Mehrere Angebote per E-Mail, mit Bildern und verschiedenen Optionen",
  "Nicht auf Lagerware beschränkt, riesige Auswahl",
  "Die meisten Felgen in 2–3 Tagen bei uns, bereit zur Montage",
  "Montage, Auswuchten & RDKS inklusive",
  "Online anfragen oder vor Ort beraten lassen",
];

export type SpokeStyle = 'mesh' | 'split' | 'thin' | 'normal';

export interface FelgenHerstellerEntry {
  id: string;
  name: string;
  origin: string;
  founded: string;
  tagline: string;
  alcar: boolean;
  spokes: number;
  style: SpokeStyle;
  desc: string;
  stats: { v: string; l: string }[];
  models: string[];
  news: string[];
  web: string;
  image: string;
  video?: string;
  youtube?: string;
  modelImages?: { name: string; image: string }[];
}

export const felgenHersteller: FelgenHerstellerEntry[] = [
  {
    id: "bbs", name: "BBS", origin: "Schiltach · Deutschland", founded: "Gegründet 1970",
    tagline: "Die Motorsport-Legende.", alcar: false, spokes: 5, style: "mesh",
    desc: "BBS wurde 1970 von Heinrich Baumgartner und Klaus Brand im Schwarzwald gegründet. Weltbekannt für ultraleichte Schmiedefelgen, jahrzehntelange Formel-1-Präsenz und ikonische Designs. Ab 2026 mit bis zu 30% günstigerer UVP-Struktur.",
    stats: [{ v: "1970", l: "Gegründet" }, { v: "F1", l: "Motorsport" }, { v: "Schiltach", l: "Deutschland" }],
    models: ["CH-R II Unlimited", "CI-R Unlimited", "CC-R", "CH-R II", "SR", "SX", "XR", "LM"],
    news: ["CH-R II Unlimited", "CI-R Unlimited"], web: "www.bbs.com", image: imgBbs,
    video: "https://cdn.bbs.com/121/assets/images/videos/BBS_Ad_CH-RII_15sec_Website_H264.mp4",
    modelImages: [
      { name: "CH-R II", image: "https://wheelsboutique.com/wp-content/uploads/2024/05/ch-r-ii.jpg" },
      { name: "CI-R", image: "https://wheelsboutique.com/wp-content/uploads/2024/05/ci-r.jpg" },
      { name: "CC-R", image: "https://wheelsboutique.com/wp-content/uploads/2024/05/cc-r.jpg" },
      { name: "SR", image: "https://wheelsboutique.com/wp-content/uploads/2024/05/sr.jpg" },
      { name: "LM", image: "https://wheelsboutique.com/wp-content/uploads/2024/05/lm.jpg" },
    ],
  },
  {
    id: "oz-racing", name: "OZ Racing", origin: "Padova · Italien", founded: "Gegründet 1971",
    tagline: "Italiens Rennstreckenerbe.", alcar: false, spokes: 5, style: "split",
    desc: "OZ Racing wurde 1971 von Silvano Oselladore und Pietro Zen in Norditalien gegründet, der Markenname setzt sich aus ihren Initialen zusammen. Seit 1984 in der Formel 1, mit Weltmeister-Teams wie Renault, Williams und Red Bull Racing.",
    stats: [{ v: "1971", l: "Gegründet" }, { v: "1984", l: "Formel 1" }, { v: "Padova", l: "Italien" }],
    models: ["Ultraleggera", "Superturismo LM", "Leggera HLT", "Ares", "Zeus", "Rally Racing"],
    news: [], web: "www.ozracing.com", image: imgOzRacing,
    modelImages: [
      { name: "Ultraleggera", image: "https://www.ozracing.com/cache/images/images/products/wheels/ultraleggera/matt-bronze/02_ultraleggera-matt-bronze-jpg%201000x750_400x333.jpg" },
      { name: "Superturismo LM", image: "https://www.ozracing.com/cache/images/images/products/wheels/superturismo-lm/matt-graphite/02_superturismo-lm-matt-graphite-jpg%201000x750_400x333.jpg" },
      { name: "Leggera HLT", image: "https://www.ozracing.com/cache/images/images/products/wheels/leggera-hlt/gloss-black/02_leggera-hlt-gloss-black-jpg%201000x750_400x333.jpg" },
      { name: "Ares", image: "https://www.ozracing.com/cache/images/images/products/wheels/ares/matt-black/02_ares-matt-black-jpg%201000x750_400x333.jpg" },
      { name: "Zeus", image: "https://www.ozracing.com/cache/images/images/products/wheels/zeus/hand-brushed/02_zeus-hand-brushed-jpg%201000x750_400x333.jpg" },
      { name: "Rally Racing", image: "https://www.ozracing.com/cache/images/images/products/wheels/rally-racing/Gloss-Black-Silver-Lettering/Rally_Racing_18_GlossBlack_SilverLettering_02_400x333.jpg" },
    ],
  },
  {
    id: "aez", name: "AEZ", origin: "ALCAR Gruppe · Österreich", founded: "ALCAR seit 1984",
    tagline: "Plug & Drive. TÜV-geprüft.", alcar: true, spokes: 10, style: "thin",
    desc: "AEZ ist eine tragende Marke der ALCAR Gruppe. Speziell für europäische Fahrzeuge entwickelt, ECE-geprüft. Neuheit 2025/26: «Tokio», erstes AEZ-Rad in 23 Zoll, Flowforge-Technologie, für Audi RSQ8, BMW X7 und Range Rover.",
    stats: [{ v: "ALCAR", l: "Gruppe" }, { v: "23\"", l: "Tokio NEU" }, { v: "ECE", l: "Zertifiziert" }],
    models: ["Tokio 23\"", "Seattle", "Toronto", "Steam", "Strike", "Crest"],
    news: ["Tokio 23\"", "Seattle"], web: "www.aez-wheels.com", image: imgAez,
    youtube: "JmpAcTl7UEA",
    modelImages: [
      { name: "Tokio", image: "https://www.aez-wheels.com/EN/repos/evoscripts/aez/img/f07077fb414a3ff0e9966990c18ef2793fab4ff8/1498-imagespecial1-448x448.png" },
      { name: "Seattle", image: "https://www.aez-wheels.com/EN/repos/evoscripts/aez/img/cdfc6b6ac8190feeae639f2f6af865a11ef75571/1499-imagespecial1-448x448.png" },
      { name: "Toronto", image: "https://www.aez-wheels.com/EN/repos/evoscripts/aez/img/8f412e362b4dc02237d21662f58802f950b38500/1478-imagespecial1-448x448.png" },
    ],
  },
  {
    id: "dezent", name: "Dezent", origin: "ALCAR Gruppe · Österreich", founded: "ALCAR seit 1984",
    tagline: "Zeitlose Eleganz.", alcar: true, spokes: 8, style: "thin",
    desc: "Dezent steht für elegantes Design mit klarer Formensprache. Als Teil der ALCAR Gruppe mit ECE-Zulassungen und E-Mobility-Sortiment. Neuheit 2025/26: DEZENT KG jetzt auch in Silver, für schwere Fahrzeuge mit bis zu 910 kg Traglast.",
    stats: [{ v: "ALCAR", l: "Gruppe" }, { v: "910 kg", l: "Max. Traglast" }, { v: "ECE", l: "Zertifiziert" }],
    models: ["KG Silver", "KG Dark", "KG Black", "TH", "TY", "TZ", "TA"],
    news: ["KG Silver"], web: "www.dezent.com", image: imgDezent,
    modelImages: [
      { name: "KG Silver", image: "https://www.dezent-wheels.com/DE/repos/evoscripts/dezent/getImageFromBinaryFiled?picid=1482&fld=ImageWhite" },
      { name: "KG Black", image: "https://www.dezent-wheels.com/DE/repos/evoscripts/dezent/getImageFromBinaryFiled?picid=1477&fld=ImageWhite" },
      { name: "KG Dark", image: "https://www.dezent-wheels.com/DE/repos/evoscripts/dezent/getImageFromBinaryFiled?picid=1476&fld=ImageWhite" },
      { name: "KF Black", image: "https://www.dezent-wheels.com/DE/repos/evoscripts/dezent/getImageFromBinaryFiled?picid=1483&fld=ImageWhite" },
      { name: "AP Black", image: "https://www.dezent-wheels.com/DE/repos/evoscripts/dezent/getImageFromBinaryFiled?picid=1485&fld=ImageWhite" },
    ],
  },
  {
    id: "dotz", name: "Dotz", origin: "ALCAR Gruppe · Österreich", founded: "ALCAR seit 1984",
    tagline: "Sportstyle. Flowforged.", alcar: true, spokes: 5, style: "split",
    desc: "Dotz steht für sportlichen Lifestyle mit technologischem Anspruch. Neuheit 2025/26: Sonoma, erstes ECE-zertifiziertes Flowforged-Rad von Dotz. Bilbao mit Vintage-Kreuzspeichen-Charme. Dakar HD für Offroad mit 1'000 kg Traglast.",
    stats: [{ v: "ALCAR", l: "Gruppe" }, { v: "Flowforge", l: "Sonoma NEU" }, { v: "1000 kg", l: "Dakar HD" }],
    models: ["Sonoma Flowforged", "Bilbao", "Dakar HD", "Outland", "Kendo", "Mugello", "Brands Hatch"],
    news: ["Sonoma Flowforged", "Bilbao", "Dakar HD"], web: "www.dotz.eu", image: imgDotz,
    modelImages: [
      { name: "Bilbao blaze", image: "https://www.dotz-wheels.com/EN/engine/Design/front-487/1493/d" },
      { name: "Bilbao dark", image: "https://www.dotz-wheels.com/EN/engine/Design/front-487/1492/d" },
      { name: "Sonoma bronze", image: "https://www.dotz-wheels.com/EN/engine/Design/front-487/1480/d" },
      { name: "Sonoma dark", image: "https://www.dotz-wheels.com/EN/engine/Design/front-487/1481/d" },
      { name: "Suzuka bronze", image: "https://www.dotz-wheels.com/EN/engine/Design/front-487/1471/d" },
      { name: "MarinaBay dark", image: "https://www.dotz-wheels.com/EN/engine/Design/front-487/1468/d" },
    ],
  },
  {
    id: "borbet", name: "Borbet", origin: "Hallenberg · Deutschland", founded: "Gegründet 1962",
    tagline: "Made in Germany. Nr. 3 weltweit.", alcar: false, spokes: 7, style: "normal",
    desc: "Borbet wurde 1962 in Hallenberg im Sauerland gegründet und ist drittgrösster Alufelgenhersteller weltweit. Sechs von acht Standorten liegen in Deutschland. OEM-Partner für Audi, BMW, VW, Ford und Mercedes-Benz.",
    stats: [{ v: "1962", l: "Gegründet" }, { v: "Nr. 3", l: "Weltweit" }, { v: "Hallenberg", l: "Deutschland" }],
    models: ["FB2DC Deep Concave", "BX15 Multispoke", "FB2", "FB1", "BTX", "B", "CW", "Y"],
    news: ["FB2DC Deep Concave", "BX15 Multispoke"], web: "www.borbet.de", image: imgBorbet,
    modelImages: [
      { name: "W", image: "https://www.borbet.de/medien/img/wheels/BorbetRaeder/160_57129_1445_364_418_crop.webp" },
      { name: "CWZ", image: "https://www.borbet.de/medien/img/wheels/BorbetRaeder/cwz_mistral_pol._2_3320_364_418_crop.webp" },
      { name: "QX", image: "https://www.borbet.de/medien/img/wheels/BorbetRaeder/qx_black-bronce-matt_02_4372_364_418_crop.webp" },
      { name: "N", image: "https://www.borbet.de/medien/img/wheels/BorbetRaeder/borbet_n_bronze_2_4175_364_418_crop.webp" },
      { name: "XV", image: "https://www.borbet.de/medien/img/wheels/BorbetRaeder/xv_black_matt_pol_2_6934_364_418_crop.webp" },
      { name: "BY", image: "https://www.borbet.de/medien/img/wheels/BorbetRaeder/10_59187_1199_364_418_crop.webp" },
    ],
  },
  {
    id: "platin", name: "Platin", origin: "Europa", founded: "–",
    tagline: "Breites Sortiment. Faire Preise.", alcar: false, spokes: 10, style: "normal",
    desc: "Platin bietet ein umfangreiches Sortiment an Alufelgen von 14 bis 21 Zoll für nahezu jeden Fahrzeugtyp. Starkes Preis-Leistungs-Verhältnis mit TÜV-konformen Homologationen für den europäischen Markt.",
    stats: [{ v: "EU", l: "Herkunft" }, { v: "TÜV", l: "Geprüft" }, { v: "21\"", l: "Max. Grösse" }],
    models: ["P90", "P100", "RP110", "Rezza", "Martigues"],
    news: [], web: "www.platin-wheels.com", image: imgPlatin,
    modelImages: [
      { name: "P 125", image: "https://www.platin-wheels.com/fileadmin/_processed_/5/b/csm_125030_3c20b2a450.jpg" },
      { name: "P 118", image: "https://www.platin-wheels.com/fileadmin/_processed_/4/a/csm_118030_93103e12ef.jpg" },
      { name: "P 115", image: "https://www.platin-wheels.com/fileadmin/_processed_/e/e/csm_115030_632e70edbb.jpg" },
      { name: "P 114", image: "https://www.platin-wheels.com/fileadmin/_processed_/0/f/csm_114030_59fb6c3de7.jpg" },
      { name: "P 113", image: "https://www.platin-wheels.com/fileadmin/_processed_/b/c/csm_113030_ab81d7bca5.jpg" },
    ],
  },
  {
    id: "gmp-italia", name: "GMP Italia", origin: "Bergamo · Italien", founded: "Gegründet 2003",
    tagline: "Simply Perfect. Made in Italy.", alcar: false, spokes: 5, style: "mesh",
    desc: "GMP Italia wurde 2003 in der Provinz Bergamo gegründet. Unter dem Motto «Simply Perfect» entstehen hochwertige Leichtmetallfelgen von 15 bis 23 Zoll. Designer Marco Finazzi, ehemals Alfa Romeo Style Center, prägt die Designlinie.",
    stats: [{ v: "2003", l: "Gegründet" }, { v: "23\"", l: "Max. Grösse" }, { v: "Bergamo", l: "Italien" }],
    models: ["Atom", "Fasten", "Matisse", "Qstar", "Ardesia"],
    news: [], web: "www.gmpitalia.com", image: imgGmpItalia,
    modelImages: [
      { name: "Materia", image: "https://www.gmpitalia.com/media/images/cache/40173-materia-black-diamond-side_png_480_480_contain_80.png?v=290119" },
      { name: "Ultrivity", image: "https://www.gmpitalia.com/media/images/cache/29314-ultrivity-bd-side_png_480_480_contain_80.png?v=290119" },
      { name: "Energia", image: "https://www.gmpitalia.com/media/images/cache/energia-bd-side-1800x1800_png_480_480_contain_80.png?v=290119" },
      { name: "Fender", image: "https://www.gmpitalia.com/media/images/cache/fender-bd-side-1800x1800_png_480_480_contain_80.png?v=290119" },
      { name: "Cartesio", image: "https://www.gmpitalia.com/media/images/cache/cartesio-bd-side-1800x1800_png_480_480_contain_80.png?v=290119" },
    ],
  },
  {
    id: "mak", name: "MAK", origin: "Brescia · Italien", founded: "Gegründet 1991",
    tagline: "Design & Passion. Made in Italy.", alcar: false, spokes: 6, style: "split",
    desc: "MAK S.p.A. wurde 1991 in Brescia als Joint Venture gegründet und ist heute nationaler Marktführer in Italien mit über 600'000 Rädern pro Jahr. Bekannt für fahrzeugspezifische Designs für BMW, Audi, Mercedes, Alfa Romeo, MINI und VW.",
    stats: [{ v: "1991", l: "Gegründet" }, { v: "600k", l: "Räder/Jahr" }, { v: "Brescia", l: "Italien" }],
    models: ["STARK-D", "MONZA", "CHELSEA", "QVARZ", "ASPHALT", "Highlands", "Luft"],
    news: ["STARK-D"], web: "www.makwheels.it", image: imgMak,
    modelImages: [
      { name: "Asphalt", image: "https://www.makwheels.it/wp-content/uploads/2024/04/ASPHALTBLACKMIRRORANT_temp-480x480.png" },
      { name: "Chelsea", image: "https://www.makwheels.it/wp-content/uploads/2024/04/CHELSEABLACKMIRRORANT-480x480.png" },
      { name: "Electra", image: "https://www.makwheels.it/wp-content/uploads/2024/04/ELECTRABLACKMIRRORANT-480x480.png" },
      { name: "Epica", image: "https://www.makwheels.it/wp-content/uploads/2024/04/EPICABLACKMIRRORANT-480x480.png" },
      { name: "Birmingham", image: "https://www.makwheels.it/wp-content/uploads/2024/04/BIRMINGHAMGLOSSBLACKANT-480x480.png" },
      { name: "Davinci", image: "https://www.makwheels.it/wp-content/uploads/2024/04/DAVINCIBLACKMIRRORANT-480x480.png" },
    ],
  },
  {
    id: "2drv", name: "2DRV Wheels", origin: "Ilsenburg im Harz · Deutschland", founded: "Wheelworld seit 2007",
    tagline: "Engineered in Germany.", alcar: false, spokes: 8, style: "normal",
    desc: "2DRV Wheels ist die 2021 neu gelaunchte Marke von Wheelworld GmbH aus Ilsenburg im Harz, in der Branche seit 2007 aktiv. Design und Entwicklung in Deutschland nach höchsten Qualitätsstandards. TÜV-geprüft, ABE für alle gängigen Fahrzeuge.",
    stats: [{ v: "2007", l: "Wheelworld" }, { v: "2021", l: "→ 2DRV" }, { v: "Harz", l: "Deutschland" }],
    models: ["WH12", "WH18", "WH26", "WH28", "WH32", "WH38"],
    news: [], web: "www.wheelworld.de", image: img2drv,
    modelImages: [
      { name: "WH37", image: "https://www.felgenoutlet.de/felgenbilder/19526_19/seo/2drv_wh37_sw.webp" },
      { name: "WH34", image: "https://www.felgenoutlet.de/felgenbilder/16331_18/seo/2drv_wh34_sp.webp" },
      { name: "WH40", image: "https://www.felgenoutlet.de/felgenbilder/22847_10/seo/2drv_wh40_sp.webp" },
      { name: "WH26", image: "https://www.felgenoutlet.de/felgenbilder/5024_40/seo/2drv_wh26_sw.webp" },
      { name: "WH34 DGMP", image: "https://www.felgenoutlet.de/felgenbilder/16336_18/seo/2drv_wh34_dgmp.webp" },
    ],
  },
];

export const felgenFaqsGlobal = [
  {
    q: "Brauchen eure Felgen eine MFK?",
    a: "Viele unserer Felgen sind CH-homologiert und brauchen keine MFK-Eintragung. Bei Felgen, die eine Eintragung benötigen, helfen wir dir beim gesamten Prozess.",
  },
  {
    q: "Was kostet ein Satz Kompletträder?",
    a: "Die Preise variieren je nach Felge, Reifengrösse und Fahrzeugtyp. PW-Kompletträder gibt es ab ca. CHF 600. Komm vorbei oder schick uns eine Anfrage, wir beraten dich persönlich.",
  },
  {
    q: "Kann ich meine eigenen Reifen auf neue Felgen montieren lassen?",
    a: "Ja, selbstverständlich. Wir montieren, wuchten und prüfen alles, egal ob du Reifen mitbringst oder bei uns kaufst.",
  },
  {
    q: "Wie finde ich die richtige Felgengrösse?",
    a: "Am einfachsten: Komm vorbei oder schick uns dein Fahrzeugmodell. Wir prüfen die zugelassenen Grössen und zeigen dir, was passt, optisch und technisch.",
  },
  {
    q: "Wie schnell bekomme ich meine Felgen?",
    a: "Die meisten Felgen sind in 2–3 Tagen bei uns vor Ort. Sobald sie da sind, montieren wir alles, Reifen aufziehen, auswuchten, RDKS prüfen. Du fährst mit fertigen Rädern vom Hof.",
  },
  {
    q: "Kann ich sehen, wie die Felge auf meinem Auto aussieht?",
    a: "Ja! Wir zeigen dir am Bildschirm verschiedene Felgen direkt auf deinem Fahrzeug, so siehst du vorher, wie's nachher aussieht.",
  },
  {
    q: "Was ist der Unterschied zwischen Stahl- und Alufelgen?",
    a: "Stahlfelgen sind günstiger und robust, ideal als Winterfelge. Alufelgen sind leichter, sehen besser aus und verbessern die Fahrdynamik. Wir helfen dir bei der Wahl.",
  },
];
